import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AppLayoutComponent } from './layout/app.layout.component';
import { ForcePasswordChangeGuard } from "./_guards/force-password-change.guard";
import { AuthPazienteGuard } from "./_guards/auth-paziente.guard";
import { AuthAdminGuard } from "./_guards/auth-admin.guard";
import { AuthMedicoGuard } from "./_guards/auth-medico.guard";
import { AuthGuard } from "./_guards/auth.guard";

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
};

const routes: Routes = [
    {
        path: '',
        component: AppLayoutComponent,
        canActivateChild: [ForcePasswordChangeGuard],
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./dashboard/dashboard.module').then(
                        (m) => m.DashboardModule
                    ),
                canActivate: [AuthGuard]
            },

            {
                path: 'paziente',
                loadChildren: () =>
                    import('./dashboard-paziente/dashboard-paziente.module').then(
                        (m) => m.DashboardPazienteModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'medico',
                loadChildren: () =>
                    import('./dashboard-medico/dashboard-medico.module').then(
                        (m) => m.DashboardMedicoModule
                    ),
                canActivate: [AuthMedicoGuard]
            },

            {
                path: 'specializzazioni',
                loadChildren: () =>
                    import('./specializzazioni/specializzazioni.module').then(
                        (m) => m.SpecializzazioniModule
                ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'provenienze',
                loadChildren: () =>
                    import('./provenienze/provenienze.module').then(
                        (m) => m.ProvenienzeModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'pazienti',
                loadChildren: () =>
                    import('./pazienti/pazienti.module').then(
                        (m) => m.PazientiModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'condizioni-consenso',
                loadChildren: () =>
                    import('./condizioni/condizioni.module').then(
                        (m) => m.CondizioniModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'medici',
                loadChildren: () =>
                    import('./medici/medici.module').then(
                        (m) => m.MediciModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'operatori',
                loadChildren: () =>
                    import('./operatori/operatori.module').then(
                        (m) => m.OperatoriModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'agenda/:medico_id',
                loadChildren: () =>
                    import('./agenda/agenda.module').then(
                        (m) => m.AgendaModule
                    ),
            },

            {
                path: 'profilomedico',
                loadChildren: () =>
                    import('./profilomedico/profilomedico.module').then(
                        (m) => m.ProfilomedicoModule
                    ),
                canActivate: [AuthMedicoGuard]
            },

            {
                path: 'profilopaziente',
                loadChildren: () =>
                    import('./profilopaziente/profilopaziente.module').then(
                        (m) => m.ProfilopazienteModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'modificaconsensi',
                loadChildren: () =>
                    import('./modificaconsensi/modificaconsensi.module').then(
                        (m) => m.ModificaconsensiModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'preferenzeutente',
                loadChildren: () =>
                    import('./preferenzeutente/preferenzeutente.module').then(
                        (m) => m.PreferenzeutenteModule
                    ),
                canActivate: [AuthGuard]
            },

            {
                path: 'anamnesipaziente',
                loadChildren: () =>
                    import('./anamnesipaziente/anamnesipaziente.module').then(
                        (m) => m.AnamnesipazienteModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'privacy-consulto',
                loadChildren: () =>
                    import('./privacy-consulto/privacy-consulto.module').then(
                        (m) => m.PrivacyConsultoModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'cambiapassword',
                loadChildren: () =>
                    import('./cambiapassword/cambiapassword.module').then(
                        (m) => m.CambiapasswordModule
                    ),
                canActivate: [AuthGuard]
            },

            {
                path: 'consulto/:consulto_id',
                loadChildren: () =>
                    import('./consulto/consulto.module').then(
                        (m) => m.ConsultoModule
                    ),
                canActivate: [AuthMedicoGuard]
            },

            {
                path: 'consultopaziente/:consulto_id',
                loadChildren: () =>
                    import('./consultopaziente/consultopaziente.module').then(
                        (m) => m.ConsultopazienteModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'consulti/:stato',
                loadChildren: () =>
                    import('./consulti/consulti.module').then(
                        (m) => m.ConsultiModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'consulti',
                loadChildren: () =>
                    import('./consulti/consulti.module').then(
                        (m) => m.ConsultiModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'feedback',
                loadChildren: () =>
                    import('./feedback/feedback.module').then(
                        (m) => m.FeedbackModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'consultimedico/:stato',
                loadChildren: () =>
                    import('./consultimedico/consultimedico.module').then(
                        (m) => m.ConsultimedicoModule
                    ),
                canActivate: [AuthMedicoGuard]
            },

            {
                path: 'consultimedico',
                loadChildren: () =>
                    import('./consultimedico/consultimedico.module').then(
                        (m) => m.ConsultimedicoModule
                    ),
                canActivate: [AuthMedicoGuard]
            },

            {
                path: 'consultipaziente',
                loadChildren: () =>
                    import('./consultipaziente/consultipaziente.module').then(
                        (m) => m.ConsultipazienteModule
                    ),
                canActivate: [AuthPazienteGuard]
            },

            {
                path: 'creavisita',
                loadChildren: () =>
                    import('./creavisita/creavisita.module').then(
                        (m) => m.CreavisitaModule
                    ),
                canActivate: [AuthAdminGuard]
            },

            {
                path: 'fatture',
                loadChildren: () =>
                    import('./fatture/fatture.module').then(
                        (m) => m.FattureModule
                    ),
                canActivate: [AuthGuard]
            },
            {
                path: 'marche-da-bollo',
                loadChildren: () =>
                    import('./marchedabollo/marchedabollo.module').then(
                        (m) => m.MarcheDaBolloModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'logs',
                loadChildren: () =>
                    import('./logs/logs.module').then(
                        (m) => m.LogsModule
                    ),
                canActivate: [AuthAdminGuard]
            },
/*
            {
                path: 'fatture/:destinatari',
                loadChildren: () =>
                    import('./fatture/fatture.module').then(
                        (m) => m.FattureModule
                    ),
                canActivate: [AuthAdminGuard]
            },
*/
            {
                path: 'convenzioni',
                loadChildren: () =>
                    import('./convenzioni/convenzioni.module').then(
                        (m) => m.ConvenzioniModule
                    ),
                canActivate: [AuthAdminGuard]
            },
           {
                path: 'voucher',
                loadChildren: () =>
                    import('./voucher/voucher.module').then(
                        (m) => m.VoucherModule
                    ),
               canActivate: [AuthAdminGuard]
            },


            {
                path: 'pages',
                data: { breadcrumb: 'Pages' },
                loadChildren: () =>
                    import('./pages/pages.module').then(
                        (m) => m.PagesModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () =>
                    import('./demo/components/uikit/uikit.module').then(
                        (m) => m.UIkitModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'utilities',
                data: { breadcrumb: 'Utilities' },
                loadChildren: () =>
                    import('./demo/components/utilities/utilities.module').then(
                        (m) => m.UtilitiesModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'pages',
                data: { breadcrumb: 'Pages' },
                loadChildren: () =>
                    import('./demo/components/pages/pages.module').then(
                        (m) => m.PagesModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'profile',
                data: { breadcrumb: 'User Management' },
                loadChildren: () =>
                    import('./demo/components/profile/profile.module').then(
                        (m) => m.ProfileModule
                    ),
                canActivate: [AuthAdminGuard]
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadChildren: () =>
                    import(
                        './demo/components/documentation/documentation.module'
                    ).then((m) => m.DocumentationModule),
            },
            {
                path: 'blocks',
                data: { breadcrumb: 'Prime Blocks' },
                loadChildren: () =>
                    import(
                        './demo/components/primeblocks/primeblocks.module'
                    ).then((m) => m.PrimeBlocksModule),
            },
            {
                path: 'ecommerce',
                data: { breadcrumb: 'E-Commerce' },
                loadChildren: () =>
                    import('./demo/components/ecommerce/ecommerce.module').then(
                        (m) => m.EcommerceModule
                    ),
            },
            {
                path: 'apps',
                data: { breadcrumb: 'Apps' },
                loadChildren: () =>
                    import('./demo/components/apps/apps.module').then(
                        (m) => m.AppsModule
                    ),
            },
        ],
    },
    {
        path: 'auth',
        data: { breadcrumb: 'Auth' },
        loadChildren: () =>
            import('./demo/components/auth/auth.module').then(
                (m) => m.AuthModule
            ),
    },
    {
        path: 'notfound',
        loadChildren: () =>
            import('./demo/components/notfound/notfound.module').then(
                (m) => m.NotfoundModule
            ),
    },
    {
        path: 'landing',
        loadChildren: () =>
            import('./demo/components/landing/landing.module').then(
                (m) => m.LandingModule
            ),
    },

    {
        path: 'login',
        loadChildren: () =>
            import('./login/login.module').then(
                (m) => m.LoginModule
            )
    },

    {
        path: 'registrazione',
        loadChildren: () =>
            import('./registrazione/registrazione.module').then(
                (m) => m.RegistrazioneModule
            )
    },

    {
        path: 'checkout/:code',
        loadChildren: () =>
            import('./checkout/checkout.module').then(
                (m) => m.CheckoutModule
            )
    },

    {
        path: 'preconsultopaziente/:consulto_id',
        loadChildren: () =>
            import('./preconsultopaziente/preconsultopaziente.module').then(
                (m) => m.PreconsultopazienteModule
            ),
        canActivate: [AuthPazienteGuard]
    },

    {
        path: 'forzacambiopassword',
        loadChildren: () =>
            import('./forzacambiopassword/forzacambiopassword.module').then(
                (m) => m.ForzacambiopasswordModule
            )
    },

    {
        path: 'prestaconsensi',
        loadChildren: () =>
            import('./prestaconsensi/prestaconsensi.module').then(
                (m) => m.PrestaconsensiModule
            )
    },

    {
        path: 'doubleoptin',
        loadChildren: () =>
            import('./doubleoptin/doubleoptin.module').then(
                (m) => m.DoubleoptinModule
            )
    },

    {
        path: 'recupera-password',
        loadChildren: () =>
            import('./recupera-password/recupera-password.module').then(
                (m) => m.RecuperaPasswordModule
            )
    },

    {
        path: 'recupera-password-cambia',
        loadChildren: () =>
            import('./recupera-password-cambia/recupera-password-cambia.module').then(
                (m) => m.RecuperaPasswordCambiaModule
            )
    },

    { path: '**', redirectTo: '/notfound' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
